import { render, staticRenderFns } from "./CustomerPending.vue?vue&type=template&id=7219c7fa&scoped=true&"
import script from "./CustomerPending.vue?vue&type=script&lang=js&"
export * from "./CustomerPending.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPending.vue?vue&type=style&index=0&id=7219c7fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7219c7fa",
  null
  
)

export default component.exports